import { Tool } from './interfaces/tool.interface';

export const tools: Array<Tool> = [
  {
    name: 'Configuration WiFi/Code',
    description: 'Permet de créer le fichier de configuration du WiFi et du code praticien.',
    link: '/toolbox/config-wifi-code',
  },
  {
    name: 'Installation personnalisée',
    description: 'Permet de faire une installation personnalisée sur le casque.',
    link: '/toolbox/custom-install',
  },
];
